import React from 'react';
import {
    StyleSheet,
    Image,
    View,
    Text,
    Dimensions,
    TouchableOpacity,
    Platform,
    ScrollView,
    Button,
} from 'react-native';
import PropTypes from 'prop-types';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
import CustomDatePicker from '../components/CustomDatePickerComponent/CustomDatePickerComponent';
import MapView from 'react-native-maps';
import { InfoWindow, DirectionsRenderer } from 'react-google-maps';
import axios from 'axios';
const { width, height } = Dimensions.get('window');
import UserPersistence from '../singletons/UserPersistence';
import config from '../../config.json';
import { Table, Row } from 'react-native-table-component';
import Picker from '../components/Picker';
import { LinearGradient } from '../components/LinearGradient';
//import { Popup } from 'react-leaflet';
//引入PaymentModal组件
import PaymentModal from '../components/paymentModalComponent/paymentModalComponent';
import RCTTask from '../components/RCTTask/RCTTask';
const ASPECT_RATIO = width / height;
const LATITUDE = 38.78825;
const LONGITUDE = -98.4324;
const LATITUDE_DELTA = 15;
const LONGITUDE_DELTA = LATITUDE_DELTA * ASPECT_RATIO;
let id = 0;
const react_native_web_maps = true; //now use react-native-maps
var ProviderPropType;
if (Platform.OS == 'web' && react_native_web_maps == true) {
    ProviderPropType = PropTypes.string;
} else {
    ProviderPropType = MapView.ProviderPropType;
}

export const filterOptions = [
    { label: '30 sec', value: 30 },
    { label: '1 minute', value: 60 },
    { label: '2 minute', value: 2 * 60 },
    { label: '5 minute', value: 5 * 60 },
    { label: '15 minute', value: 15 * 60 },
    { label: '30 minute', value: 30 * 60 },
    { label: '1 hour', value: 60 * 60 },
];

class CustomMarkers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            region: {
                latitude: LATITUDE,
                longitude: LONGITUDE,
                latitudeDelta: LATITUDE_DELTA,
                longitudeDelta: LONGITUDE_DELTA,
            },
            selectedMarker: null,
            markers: [],
            tableMarkers: [],
            userMarkers: [],
            zoom: 0.28 * this.radiusToZoom(5),

            tableHead: ['Name', 'Mph', 'S.', 'E.', 'Monitor'],
            widthArr: [135, 75, 70, 75, 140],
            startdate: null,
            enddate: null,
            viewStyle: null,
            time: '0:0',
            showMarker: true,
            showNativeMarker: false,
            mapStyle: null,
            tableStyle: null,
            mainLayout: null,
            scrollViewLayout: null,
            filter: '300',
            isLoading: true,
            showModal: false,
            classIsB: false,
            destination: '',
            origin: '',
            directions: null,
            googleMapsApiKey : 'AIzaSyDXtwQ9T63QewTtokZExpuC4xDdiW1empE',
            showRCTTask: false,
            pounchHeader: [],
            pounchData: []
        };
        this.destinationRef = React.createRef(),
        this.initialState = { ...this.state };
        this.onMapPress = this.onMapPress.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleToggleClose = this.handleToggleClose.bind(this);
        this.isResponseOk = this.isResponseOk.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
        this.onFocusFunction = this.onFocusFunction.bind(this);
        this.getAll = this.getAll.bind(this);
        this.getEngineIcon = this.getEngineIcon.bind(this);
        this.intervalId = null;
        this.scrollView = null;
        this.clickCount = 0;
    }
    static navigationOptions = (props) => {
        return {
            gesturesEnabled: this.props.creating ? false : true,
        };
    };

    radiusToZoom(r) {
        var w = width;
        var d = r * 2;
        var zooms = [
            ,
            21282,
            16355,
            10064,
            5540,
            2909,
            1485,
            752,
            378,
            190,
            95,
            48,
            24,
            12,
            6,
            3,
            1.48,
            0.74,
            0.37,
            0.19,
        ];
        var z = 20,
            m;
        while (zooms[--z]) {
            m = zooms[z] * w;
            if (d < m) {
                break;
            }
        }
        return z;
    }

    elementButton(marker) {
        return (
            <TouchableOpacity onPress={() => this.findOneVehicle(marker)}>
                <View style={styles.btn}>
                    <Text style={styles.btnText}>{marker.nickName.trim()}</Text>
                </View>
            </TouchableOpacity>
        );
    }
    onMapPress(e) {
        var coordinate;
        if (e.latLng == null) {
            coordinate = e.nativeEvent.coordinate;
        } else {
            coordinate = { latitude: e.latLng.lat(), longitude: e.latLng.lng() };
        }
        this.setState({
            userMarkers: [
                ...this.state.userMarkers,
                {
                    coordinate: coordinate,
                    key: `userMarker${id++}`,
                },
            ],
        });
    }

    handleStartChange = (selectedDate) => {
        this.setState({ 
            startdate: selectedDate,
            pounchData:[],
            pounchHeader:[]

        });
    };
    handleEndChange = (selectedDate) => {
        this.setState({ 
            enddate: selectedDate 
        });
    };
    handleToggleClose() {
        //this.intervalID = setInterval(() => {this.getAll()}, 10000);
        var markers = this.state.markers;
        var index = markers.indexOf(this.state.selectedMarker);
        if (this.state.selectedMarker != null) {
            this.state.selectedMarker.infoWindow = null;
            this.state.selectedMarker.selectedMarker = false;
        }
        markers[index] = this.state.selectedMarker;
        this.setState({ markers: markers, selectedMarker: null });
    }
    handleClick(marker) {

        clearInterval(this.intervalID);
        var markers = this.state.markers;
        var matchMarker;
        var coordinate;
        if (this.state.selectedMarker != null) {
            this.state.selectedMarker.infoWindow = null;
            this.state.selectedMarker.selectedMarker = false;
        }
        if (marker.latLng != null) {
            coordinate = {
                latitude: marker.latLng.lat(),
                longitude: marker.latLng.lng(),
            };

        } else if (marker.nativeEvent != null) {
            coordinate = marker.nativeEvent.coordinate;
        } else {
            var lat = this.ConvertToLat(marker.latitude);
            var lng = this.ConvertToLng(marker.longtitude);
            coordinate = { latitude: lat, longitude: lng };
        }
        for (var i = 0; i < markers.length; i++) {
            var mar = markers[i];
            if (
                this.ConvertToLat(mar.latitude) == coordinate.latitude &&
                this.ConvertToLng(mar.longtitude) == coordinate.longitude
            ) {
                matchMarker = mar;
            }
        }
        if (matchMarker == null) {
            var markers = this.state.tableMarkers;
            for (var i = 0; i < markers.length; i++) {
                var mar = markers[i];
                if (
                    this.ConvertToLat(mar.latitude) == coordinate.latitude &&
                    this.ConvertToLng(mar.longtitude) == coordinate.longitude
                ) {
                    matchMarker = mar;
                }
            }
        }
        if (matchMarker.latitude != null) {
            var index = markers.indexOf(matchMarker);
            var lat = this.ConvertToLat(matchMarker.latitude);
            var lng = this.ConvertToLng(matchMarker.longtitude);
            var date = matchMarker.date + '';
            var time = matchMarker.time + '';
            var driver = matchMarker.driver;
            if (driver == 'UNDEFINED' || driver == null || driver == undefined) {
                driver = '';
            }
            var US_DateStr =
                date.substring(2, 4) +
                '/' +
                date.substring(0, 2) +
                '/' +
                date.substring(4);
            var TimeStr =
                time.substring(0, 2) +
                ':' +
                time.substring(2, 4) +
                ':' +
                time.substring(4, 6);
            fetch(
                'https://maps.googleapis.com/maps/api/geocode/json?address=' +
                lat +
                ',' +
                lng +
                '&key=AIzaSyDXtwQ9T63QewTtokZExpuC4xDdiW1empE'
            )
                .then((response) => response.json())
                .then((responseJson) => {
                    //console.log("responseJson is "+responseJson);
                    var address = responseJson.results[0].formatted_address.replace(
                        ', USA',
                        ''
                    );
                    //console.log('已经拿到address: '+ address);

                    this.setState({origin: address});

                    if(this.state.directions){
                        this.setState({
                            directions: null
                        })
                    }
                    if (Platform.OS == 'web' && react_native_web_maps) {
                        matchMarker.infoWindow = (
                            <InfoWindow
                                onCloseClick={() => {
                                    this.handleToggleClose();
                                }}
                            >
                                <div style={{ fontSize: '11pt', overflow: 'auto' }}>
                                    <div style={{ paddingBottom: '5px' }}></div>
                                    <div>Location:{address}</div>
                                    <div>
                                        Plate: {matchMarker.plateNumber} | Driver :{driver}
                                    </div>
                                    <div>Speed: {Math.floor(matchMarker.speed)} mi </div>
                                    <div>Time: {US_DateStr + ' ' + TimeStr} </div>
                                    <div>
                                        <input type="text" id="todestination" ref={this.destinationRef}/>
                                        &nbsp;&nbsp;
                                        <input type="button" value="Go" onClick={this.search} />
                                    </div>
                                </div>
                            </InfoWindow>
                        );
                    } else {
                        matchMarker.infoWindow = (
                            <MapView.Callout>
                                <View style={[styles.container, this.props.style]}>
                                    <Text>Location:{address}</Text>
                                    <Text>
                                        Plate: {matchMarker.plateNumber} | Driver :{driver}
                                    </Text>
                                    <Text>Speed: {Math.floor(matchMarker.speed)} mi</Text>
                                    <Text>Time: {US_DateStr + ' ' + TimeStr}</Text>
                                    <Input
                                        leftIcon={
                                            <Icon
                                                name="map-marker"
                                                type="font-awesome"
                                                color="#86939e"
                                                size={25}
                                            />
                                        }
                                        leftIconContainerStyle={{ marginLeft: 0, marginRight: 10 }}
                                        containerStyle={styles.inputContainerStyle}
                                        placeholder="Input with left icon"
                                    />
                                    <Button text="go" onClick={this.search} />
                                </View>
                            </MapView.Callout>
                        );
                    }
                    markers[index] = matchMarker;
                    matchMarker.selectedMarker = true;
                    this.setState({ selectedMarker: matchMarker, markers: markers });
                    if (Platform.OS == 'web' && !react_native_web_maps) {
                        if (marker.nativeEvent != null) {
                            marker.nativeEvent.target.openPopup();
                        } else {
                            marker.markerRef.marker.ref.leafletElement.openPopup();
                        }
                    }
                });
        }
    }
    search = () => {
        const destination = this.destinationRef.current.value;
        if(destination){

            this.setState({destination : destination});
        }
        //console.log(this.state.destination);  
        //console.log(this.state.origin);

        if(this.state.destination){
            const directionsServices = new google.maps.DirectionsService();
            directionsServices.route(
                {
                    origin: this.state.origin,
                    destination: this.state.destination,
                    travelMode: 'DRIVING'
                },
                (result, status)=>{
                    if(status==='OK'){
                        this.setState({directions: result})
                    }else{
                        console.error(`error fetching directions ${result}`);
                    }
                }
            )
        }else{
            alert('please input your destination')
        }
    }
    findOneVehicle(marker) {
        if (width <= 640) {
            this.scrollView.scrollTo({ x: 0, y: 0, animated: true });
        }
        // marker.selectedMarker = true;
        var lat = this.ConvertToLat(marker.latitude);
        var lng = this.ConvertToLng(marker.longtitude);
        this.setState({
            pounchData: [],
            pounchHeader: [],
            markers: this.state.tableMarkers,
            rowStyle: { backgroundColor: 'green' },
            zoom: 20,
            region: {
                latitude: lat,
                longitude: lng,
                latitudeDelta: LATITUDE_DELTA / 75,
                longitudeDelta: LONGITUDE_DELTA / 75,
            },
            /**
             * 添加选中状态的判定 选择下一个车辆时 重置上一个车辆得样式
             */
            selectedMarker: marker,
            tableMarkers: this.state.tableMarkers.map((m) => {
                if (m !== marker) {
                    m.selectedMarker = false;
                } else {
                    m.selectedMarker = true;
                }
                return m;
            }),
        });
        this.handleClick(marker);
    }
    findAll() {
        this.setState({ isLoading: true });
        if (width <= 640) {
            this.scrollView.scrollTo({ x: 0, y: 0, animated: true });
        }
        this.setState(this.initialState);
        this.componentWillMount();
        this.onFocusFunction();
    }
    onFocusFunction() {
        if (UserPersistence.getInstance().userId == null) {
            //this.props.navigation.navigate('Login');
            return;
        }
        this.getAll();
        this.intervalID = setInterval(() => {
            //this.getAll()
        }, 10000);
    }
    //控制缴费提示框的关闭操作
    handleCloseModal=()=>{
        this.setState({
            showModal: false,
        })
    }
    handleCloseRCTModal=()=>{
        this.setState({
            showRCTTask: false,
        })
    }
    handleLinkClick = () => {
        this.props.navigation.navigate('Bill')
    }

    checkUserClass = () => {
        const userClass = UserPersistence.getInstance().userClass;
        //console.log(userClass);
        if(userClass ==='B'){
            this.setState({
                showModal: true,
                classIsB: true,
            })
        }else if(userClass ==='C'){
            alert('You can NOT view website untill you pay the service fee in full!')
            this.props.navigation.navigate('Login');
        }
    }


    getAll() {
        var userName = UserPersistence.getInstance().userName;
        var userId = UserPersistence.getInstance().userId;
        var getAllParams = {
            UserName: userName,
            userId: userId,
        };

        this.checkUserClass();


        axios
            .post(
                config.user.protocol +
                config.user.address +
                ':' +
                config.user.port +
                '/WebSite/GetAll',
                {},
                {
                    params: { data: JSON.stringify(getAllParams) },
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Auth-User': UserPersistence.getInstance().userId,
                        'X-Auth-Token': UserPersistence.getInstance().userAccessToken,
                        'access-control-allow-origin': '*',
                    },
                }
            )
            .then((res) => {
                //console.log('response ' + JSON.stringify(res));
                if (this.isResponseOk(res)) {
                    var viewStyle;
                    var allLocations = res.data;
                    UserPersistence.getInstance().vehicleInfo = allLocations;
                    if (allLocations.length < 4)
                        viewStyle = { viewStyle: { height: '50' } };
                    if (allLocations.length > 4 && allLocations.length < 7)
                        viewStyle = { viewStyle: { height: '200' } };
                    if (allLocations.length > 10)
                        viewStyle = { viewStyle: { height: '300' } };
                    var middle = Math.floor(allLocations.length / 2);
                    var lat = this.ConvertToLat(allLocations[middle].latitude);
                    var lng = this.ConvertToLng(allLocations[middle].longtitude);

                    this.setState({
                        markers: allLocations,
                        tableMarkers: allLocations,
                        viewStyle: viewStyle,
                        isLoading: false,
                        region: {
                            latitude: lat,
                            longitude: lng,
                            latitudeDelta: LATITUDE_DELTA / 0.5,
                            longitudeDelta: LONGITUDE_DELTA / 0.5,
                        },
                    });
                } else {
                    this.setState({ isLoading: false });
                    alert('Find All Error');
                }
                // starting websocket
                //this.onStartSocket();
            });
    }
    isResponseOk(res) {
        if (res.status == 200 && res.data != null && res.data != "") {
            return true;
        } else {
            return false;
        }
    }

    componentWillUnmount() {
        this.focusListener.remove();
    }
    componentWillMount() {
        if (width >= 640) {
            this.setState({
                mapStyle: styles.mapStyleLandscape,
                tableStyle: styles.tableStyleLandscape,
                mainLayout: styles.mainStyleLandscape,
                scrollViewLayout: styles.scrollViewLandscape,
                showNativeMarker: !react_native_web_maps,
            });
        } else {
            this.setState({
                mapStyle: styles.mapStylePortrait,
                tableStyle: styles.tableStylePortrait,
                mainLayout: styles.scrollViewPortrait,
                scrollViewLayout: styles.mainStylePortrait,
                showNativeMarker: !react_native_web_maps,
                zoom: 0.19 * this.radiusToZoom(5),
            });
        }
    }
    async componentDidMount() {
        this.focusListener = this.props.navigation.addListener('didFocus', () => {
            this.onFocusFunction();
        });
    }
    ConvertToLat(LatStr) {
        // console.log("converttolat: "+LatStr);
        if (LatStr == null) {
            LatStr = '+3806.1111';
        }
        var LatDegrees = parseInt(LatStr.substring(0, 3));
        var LatMinutes = parseFloat(LatStr.substring(3)) / 60;
        var LatitudeDouble = LatDegrees + LatMinutes;
        return LatitudeDouble;
    }
    ConvertToLng(LongStr) {
        // console.log("converttolng: "+LongStr);
        if (LongStr == null) {
            LongStr = '-11708.2211';
        }
        var LongDegrees = parseInt(Math.abs(parseFloat(LongStr.substring(0, 4))));
        var LongMinutes = parseFloat(LongStr.substring(4)) / 60;
        var LongtitudeDouble = 0 - (LongDegrees + LongMinutes);
        return LongtitudeDouble;
    }
    GetFittedIcon(Speed, AngleStr, EngineStatus) {
        var IconLink = '';
        if (Speed > 0) {
            var Angle = parseFloat(AngleStr);
            if (Angle > 345 || Angle <= 15) {
                IconLink = require('../../assets/icons/markers/mg-n.png');
            }
            if (Angle > 15 && Angle <= 60) {
                IconLink = require('../../assets/icons/markers/mg-ne.png');
            }
            if (Angle > 60 && Angle <= 105) {
                IconLink = require('../../assets/icons/markers/mg-ne.png');
            }
            if (Angle > 105 && Angle <= 150) {
                IconLink = require('../../assets/icons/markers/mg-se.png');
            }
            if (Angle > 150 && Angle <= 195) {
                IconLink = require('../../assets/icons/markers/mg-s.png');
            }
            if (Angle > 195 && Angle <= 240) {
                IconLink = require('../../assets/icons/markers/mg-sw.png');
            }
            if (Angle > 240 && Angle <= 285) {
                IconLink = require('../../assets/icons/markers/mg-w.png');
            }
            if (Angle > 285 && Angle <= 345) {
                IconLink = require('../../assets/icons/markers/mg-nw.png');
            }
        } else {
            IconLink = require('../../assets/icons/markers/mp.png');
        }
        if (Speed == 0 && EngineStatus == 'H') {
            //-- new firmware engine status
            IconLink = require('../../assets/icons/markers/m-stop.png');
        }

        if (Speed == 0 && EngineStatus == 'O') {
            IconLink = require('../../assets/icons/markers/m-stop.png');
        }

        var icon;
        if (Platform.OS == 'web' && react_native_web_maps) {
            icon = {
                url: IconLink,
                labelOrigin: new google.maps.Point(40, 32),
            };
        } else {
            icon = IconLink;
        }
        return icon;
    }
    getEngineIcon(engineStatus) {
        var IconLink;
        //alert(engineStatus);
        if (engineStatus == 'O' || engineStatus == 'H' || engineStatus == 'M') {
            IconLink = require('../../assets/icons/markers/e-on.png');
        } else {
            IconLink = require('../../assets/icons/markers/e-off.png');
        }
        var icon = (
            <View styles={{ alignItems: 'center' }}>
                <Image
                    style={{ width: '16px', height: '16px' }}
                    source={{ uri: IconLink }}
                />
            </View>
        );
        return icon;
    }
    getVideo(ipport) {
        var icon;
        if (ipport == '0.0.0.0:0') {
            icon = null;
        } else {
            icon = require('../../assets/icons/markers/camera.png');
        }
        return (
            <View>
                <Image source={icon} />
            </View>
        );
    }
    toCordinate(marker) {
        var cordinate = {
            latitude: this.ConvertToLat(marker.latitude),
            longitude: this.ConvertToLng(marker.longtitude),
        };
        return cordinate;
    }
    //时间转换器
    secondConverter = (time) => {
        const baseTime = new Date(2007, 0, 1, 0, 0, 0); // 以2007-01-01 作为起始时间
        const currentSecond = Math.floor(time.getTime()/1000); //转换成秒为单位
        //console.log('currentSecond: ' + currentSecond);
        const baseSecond = Math.floor(baseTime.getTime()/1000); // 计算基准的second
        //console.log('baseSecond: '+baseSecond);
        const convertedSecond = currentSecond-baseSecond;
        //console.log('convertedSecond: ' + convertedSecond);
        return convertedSecond;
    }
    //计算所有点的distance总和
    caculateTotalDistance = (points)=>{
        let totalDistance = 0;
        for(let i = 0; i < points.length; i++){
            const {distance} = points[i];
            totalDistance += parseInt(distance);
        }
        return totalDistance;
    }

    /**
     * 计算所有点的distance总和，计算partdistance作为参考值（partdistance = totaldistance/53）
     * 计算当前点与上一个点间的距离 如果大于partdistance，显示当前点
     */
    filterReplayPointsWithDistance = (allPoints)=>{
        //get the total distance
        const totalDistance = this.caculateTotalDistance(allPoints);
        //console.log(totalDistance);
        /**calculate the average distance between points
        there are only 50 points + start and end points, so total is 52 points,
        if divied with 55, it always show the 52 points, if 54, some times, only 49 points*/
        const partDistance = totalDistance / 53;
        //console.log(partDistance);
        const resultPoints = [];
        const len = allPoints.length;
        if(len<=0) return;

        resultPoints.push[allPoints[0]];
        let showPointOffset = 0;
        for(let i = 1; i < len; i++){
            let singleOffSet = parseInt(allPoints[i].distance);
            let serialNumber = allPoints[i].serialNumber;
            showPointOffset += singleOffSet;

            if(showPointOffset > partDistance || serialNumber.startsWith('21')){
                resultPoints.push(allPoints[i]);
                showPointOffset = 0;
            }
        }
        return resultPoints;
    }
    viewRoute() {
        this.checkUserClass();
        if (this.state.selectedMarker == null) {
            alert('Please select a car to View Route');
            return;
        }
        // this.setState({
        //     markers: [],
        // });
        if(this.state.pounchData.length > 0) {
            this.setState({ isLoading: false, showRCTTask: true });
            return;
        }
        /*
        alert('Not Ready');
        return;*/
        const vehicleId = this.state.selectedMarker.vehicleId;
        var selectedDate = this.state.startdate;
        if(selectedDate == null) {
            var date = new Date();
            var utcDate = new Date(date.toUTCString());
            utcDate.setHours(utcDate.getHours()-8);
            selectedDate = utcDate.toISOString().slice(0, 10);
        } else {
            var utcDate = new Date(selectedDate.toUTCString());
            utcDate.setHours(utcDate.getHours()-8);
            selectedDate = utcDate.toISOString().slice(0, 10);
        }
        //this.setState({ isLoading: false });
        this.setState({ isLoading: false,  showRCTTask: true });
        axios
            .get(
                    config.user.protocol +
                    config.user.address +
                    ':' +
                    //config.user.port +
                    + '443' +
                    //'/getRCTRouteInfo' +
                    "/customers/mappoints.aspx" +
                    '?userName=rct&' + // only rct has view route
                    'vid=' +
                    vehicleId +
                    '&routeDate=' +
                    selectedDate,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Auth-User': UserPersistence.getInstance().userId,
                            'X-Auth-Token': UserPersistence.getInstance().userAccessToken,
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (this.isResponseOk(res)) {
                        var points = res.data;
                        var tasks = points.taskPoints;
                        var tasksObject = JSON.parse(tasks);
                        //console.log("处理前数据数目" + JSON.stringify(tasksObject));
                        var pounchHeader = [];
                        var deliveryData = {};
                        deliveryData.name = "Vehicle";
                        deliveryData.value = points.nickName;
                        pounchHeader.push(deliveryData);
                        deliveryData = {};
                        deliveryData.name = "Driver";
                        deliveryData.value = points.driver;
                        pounchHeader.push(deliveryData);
                        deliveryData = {};
                        deliveryData.name = "Tel";
                        deliveryData.value = points.tel;
                        pounchHeader.push(deliveryData);
                        deliveryData = {};
                        deliveryData.name = "Route";
                        deliveryData.value = points.route;
                        pounchHeader.push(deliveryData);
                        deliveryData = {};
                        deliveryData.name = "Pouch In";
                        deliveryData.value = points.pounchIn;
                        pounchHeader.push(deliveryData);
                        deliveryData = {};
                        deliveryData.name = "Leave";
                        deliveryData.value = points.LeaveTimeStr;
                        pounchHeader.push(deliveryData);
                        deliveryData = {};
                        deliveryData.name = "Return";
                        deliveryData.value = points.returnTime;
                        pounchHeader.push(deliveryData);
                        deliveryData = {};
                        deliveryData.name = "Pounch Out";
                        deliveryData.value = points.pounchOut;
                        pounchHeader.push(deliveryData);
                        deliveryData = {};
                        deliveryData.name = "Total Time";
                        deliveryData.value = points.totalTime;
                        pounchHeader.push(deliveryData);
                        var pounchData = [];
                        const directionsService = new google.maps.DirectionsService();
                        const origin = { lat:   parseFloat(points.companyLat), lng: parseFloat(points.companyLng) };
                        destination = { lat: parseFloat(tasksObject[tasksObject.length-1].Latitude), lng:  parseFloat(tasksObject[length-1].Longtitude)};
                        //console.log("处理前数据数目" + JSON.stringify(destination));
                        var waypoints = [];
                        tasksObject.map((task, index) => {
                            var waypoint = {};
                            waypoint.location = new google.maps.LatLng(parseFloat(task.Latitude),  parseFloat(task.Longtitude));
                            if(index < tasksObject.length -1) {
                                waypoints.push(waypoint);
                            }
                            var data = {};
                            data.id = index;
                            data.customer = task.CustomerID;
                            data.address = task.Address;
                            data.startStopTime = this.toMinutes(task.startStopTime);
                            data.endStopTime = this.toMinutes(task.endStopTime);
                            var totalSeconds = task.StopSeconds;
                            var hours = Math.floor(totalSeconds / 3600);
                            totalSeconds %= 3600;
                            var minutes = Math.floor(totalSeconds / 60);
                            data.stopseconds =  hours +':' + minutes;
                            data.weight = parseInt(task.TotalWeight);
                            data.amount = parseInt(task.TotalAmount);
                            pounchData.push(data);
                            
                        })
                        directionsService.route(
                            {
                                origin: origin,
                                destination: destination,
                                travelMode: google.maps.TravelMode.DRIVING,
                                waypoints: waypoints
                            },
                            (result, status) => {
                                if (status === google.maps.DirectionsStatus.OK) {
                                    //console.log(result)
                                    this.setState({
                                        directions: result,
                                        markers: [],
                                        pounchData: pounchData,
                                        pounchHeader: pounchHeader
                                    });
                                } else {
                                    //console.error(`error fetching directions ${result}`);
                                }
                            }
                        );
                    } else {
                        alert("No route for " + this.state.selectedMarker.nickname + " on " + selectedDate);
                    }
                    // starting websocket
                    //this.onStartSocket();
                });
                
    }
    toMinutes(time) {
        if(time != null) {
            var date = time.trim().substring(11, 16);
            console.log("time is " + time);
            return date;
        } else {
            return "";
        }
    }
    rePlay() {
        this.checkUserClass();
        if (this.state.selectedMarker == null) {
            alert('Please select a car to replay');
            return;
        }
        this.checkUserClass();
        const vehicleId = this.state.selectedMarker.vehicleId;
        if ((( this.state.enddate - this.state.startdate) / (1000 * 60 * 60 * 24)) > 7 ) {
            alert('Error! Days are limited to less than 7 days.');
        } 
        else if ( ((this.state.enddate - this.state.startdate) / (1000 * 60 * 60 * 24)) <= 0){ 
            //console.log("start date: "+this.state.startdate);
            //console.log("end date: "+this.state.enddate);
            //console.log(`======${(this.state.enddate - this.state.startdate) / (1000 * 60 * 60 * 24)}===========`)
            alert('Error! End Date not less than Start Date');
        } else {
            this.setState({ isLoading: true });
            axios
                .get(
                    config.user.protocol +
                    config.user.address +
                    ':' +
                    config.user.port +
                    '/getReplayPoints' +
                    '?vid=' +
                    vehicleId +
                    '&begin=' +
                    this.secondConverter(this.state.startdate)+
                    '&end=' +
                    this.secondConverter(this.state.enddate),
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Auth-User': UserPersistence.getInstance().userId,
                            'X-Auth-Token': UserPersistence.getInstance().userAccessToken,
                        },
                    }
                )
                .then((res) => {
                    if (this.isResponseOk(res)) {
                        var points = res.data;
                        //console.log("处理前数据数目" + points.length);
                        //通过distance筛选需要显示的点
                        const handledPoints = this.filterReplayPointsWithDistance(points);
                        //console.log("处理后数据数目" + handledPoints.length);
                        var middle = Math.floor(handledPoints.length / 2);
                        var lat = this.ConvertToLat(handledPoints[middle].latitude);
                        var lng = this.ConvertToLng(handledPoints[middle].longtitude);
                        this.setState({
                            markers: handledPoints,
                            rowStyle: { backgroundColor: 'green' },
                            zoom: 9,
                            showMarker: false,
                            isLoading: false,
                            region: {
                                latitude: lat,
                                longitude: lng,
                                latitudeDelta: LATITUDE_DELTA / 75,
                                longitudeDelta: LONGITUDE_DELTA / 75,
                            },
                        });
                    } else {
                        this.setState({ isLoading: false });
                        alert('No replay');
                    }
                    // starting websocket
                    //this.onStartSocket();
                });
        }
    }

    //findstop所有的点以后 用该函数处理处理返回的数组，根据second值 保留second间隔this.state.filter以上的点的信息
    filterStopPointsWithFilterTime = (stopPoints, filterTime)=>{
        const result =[];
        result.push(stopPoints[0]);
        const { second } = stopPoints[0];
        let preSecond = second;
        for(let i = 1; i < stopPoints.length; i++){
            const {second} = stopPoints[i]
            if(parseInt(second)-parseInt(preSecond)>=parseInt(filterTime)){
                result.push(stopPoints[i]);
                preSecond = second;
            }else{
                continue;
            }
        }
        return result;
    }

    //通过两组经度和维度 使用Haversine公式 计算他们之间的距离
    calculatePhysicalDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371; // 地球半径（单位：千米）

        const dLat = this.toRadians(lat2 - lat1);
        const dLon = this.toRadians(lon2 - lon1);

        const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const distance = R * c;
        return distance;
    }
        
    toRadians = (degrees) => {
        return degrees * (Math.PI / 180);
    }

    /**筛选所有stopPoints 通过计算当前点和上一个点的距离 判断两点是否是用一个停车点
     * 如果是同意停车点 过滤掉 如果不是显示停车点 更新上一个停车点的经纬度信息 
     * baseDistance 判断两个点是否为同一个点 如果两个点的物理距离小于distanceThreshold则被认为是同一个点
    */
    
    filterStopPointsWithPhysicalDistance = (allStopPoints, distanceThreshold) => {
        const baseLat = 38.78825;
        const baseLng = -98.4324;

        const resultStopPoints = [];

        if(allStopPoints.length==0) return resultStopPoints;

        resultStopPoints.push(allStopPoints[0]);
        let preLoacation = this.calculatePhysicalDistance(baseLat, baseLng, allStopPoints[0].latitude, allStopPoints[0].longtitude);
        let preSec = allStopPoints[0].second;
        for(let i = 1; i < allStopPoints.length; i++){
            const currentPoint = allStopPoints[i];
            //获取当前点的经度纬度和second
            const curLat = currentPoint.latitude;
            const curLng = currentPoint.longtitude;
            const curSec = currentPoint.second;

            //计算当前的点到基准点的距离
            const curLocation = this.calculatePhysicalDistance(baseLat, baseLng, curLat, curLng);
            if(Math.abs(curLocation-preLoacation) < distanceThreshold){
                //console.log("是同一个点")
                continue;
            }else{
                resultStopPoints.push(currentPoint);
            }

            preLoacation = curLocation;
            preSec = curSec

        }

        return resultStopPoints;
    }



    findStop() {

        this.checkUserClass()

        if (this.state.selectedMarker == null) {
            alert('Please select a car first');
            return;
        }
        this.checkUserClass()
        const vehicleId = this.state.selectedMarker.vehicleId;
        if ((( this.state.enddate - this.state.startdate) / (1000 * 60 * 60 * 24)) > 3 ) {
            alert('Error! Max days is 3.');
        } else if (((this.state.enddate - this.state.startdate) / (1000 * 60 * 60 * 24)) <= 0) {
            alert('Error! End Date not less than Start Date');
        } else {
            this.setState({ isLoading: true });
            axios
                .get(
                    config.user.protocol +
                    config.user.address +
                    ':' +
                    config.user.port +
                    '/getStopPoints' +
                    '?vid=' +
                    vehicleId +
                    '&begin=' +
                    this.secondConverter(this.state.startdate) +
                    '&end=' +
                    this.secondConverter(this.state.enddate) +
                    '&filter=' +
                    this.state.filter,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Auth-User': UserPersistence.getInstance().userId,
                            'X-Auth-Token': UserPersistence.getInstance().userAccessToken,
                        },
                    }
                )
                .then((res) => {
                    if (this.isResponseOk(res)) {
                        var points = res.data;
                        //打印所有点的数目
                        //console.log("所有停车点的数目: "+points.length);
                        //处理返回数据 过滤掉同一个停车点
                        const stopPointsHandledByDistance = this.filterStopPointsWithPhysicalDistance(points, 0.1);
                        //打印经过筛选的数据数目
                        //console.log(stopPointsHandledByDistance.length);

                        const stopPointsHandledByTime = this.filterStopPointsWithFilterTime(stopPointsHandledByDistance, this.state.filter);

                        //console.log(stopPointsHandledByTime.length);

                        var middle = Math.floor(stopPointsHandledByTime.length / 2);
                        var lat = this.ConvertToLat(stopPointsHandledByTime[middle].latitude);
                        var lng = this.ConvertToLng(stopPointsHandledByTime[middle].longtitude);
                        this.setState({
                            markers: stopPointsHandledByTime,
                            rowStyle: { backgroundColor: 'green' },
                            zoom: 7,
                            showMarker: false,
                            isLoading: false,
                            region: {
                                latitude: lat,
                                longitude: lng,
                                latitudeDelta: LATITUDE_DELTA / 75,
                                longitudeDelta: LONGITUDE_DELTA / 75,
                            },
                        });
                    } else {
                        this.setState({ isLoading: false });
                        alert('No stop find');
                    }
                    // starting websocket
                    //this.onStartSocket();
                });
        }
    }
    // getOptionList() {
    //     return this.refs['OPTIONLIST'];
    // }
    onFilterChange = (value) => {
        this.setState({ filter: value });
    };
    render() {
        var OutDynamicView, InnerDynamicView;
        if (width >= 640) {
            OutDynamicView = View;
            InnerDynamicView = ScrollView;
        } else {
            this.state.mainLayout = styles.mainStylePortrait;
            OutDynamicView = ScrollView;
            InnerDynamicView = View;
        }
        const { isLoading } = this.state;
        return ( 
            <View style={styles.container}>
                {/* if user class is B pop up a modal to make a warning */}
                {this.state.classIsB && this.state.showModal && (
                    <PaymentModal
                        showModal={this.state.showModal}
                        handleCloseModal={this.handleCloseModal}
                        handleLinkClick={this.handleLinkClick}
                    />
                )}
                {
                    this.state.showRCTTask && (
                        <RCTTask
                        showModal={this.state.showRCTTask}
                        handleCloseModal={this.handleCloseRCTModal}
                        handleLinkClick={this.handleLinkClick}
                        pounchData={this.state.pounchData}
                        pounchHeader={this.state.pounchHeader} 
                    /> 
                    )
                }
                <OutDynamicView
                    contentContainerStyle={this.state.scrollViewLayout}
                    style={this.state.mainLayout}
                    ref={(ref) => (this.scrollView = ref)}
                >
                    <View style={this.state.mapStyle}>
                        <MapView
                            provider={this.props.provider}
                            style={styles.map}
                            initialRegion={this.state.region}
                            region={this.state.region}
                            onPress={this.onMapPress}
                            zoom={this.state.zoom}
                            defaultZoom={this.state.zoom}
                            scrollEnabled={false}
                            zoomControlEnabled={false}
                        >
                            {this.state.markers.map((marker) => {
                                return (<MapView.Marker
                                            title={marker.nickName}
                                            key={marker.vehicleId+'/'+Math.random()}
                                            coordinate={this.toCordinate(marker)}
                                            description={this.state.mapdesc}
                                            onPress={(marker) => this.handleClick(marker)}
                                            onClick={(marker) => this.handleClick(marker)}
                                            icon={this.GetFittedIcon(
                                                Math.floor(marker.speed),
                                                marker.course,
                                                marker.engine
                                            )}
                                            label={
                                                {
                                                    text: this.state.showMarker && marker.nickName,
                                                    // text:  marker.nickName,
                                                    fontFamily: 'Arial',
                                                    fontSize: '16px',
                                                    color: 'black',
                                                    // fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    x: '400',
                                                    y: '100',
                                                }
                                            }
                                            ref={(ref) => (marker.markerRef = ref)}
                                        >
                                            {marker.infoWindow}

                                            <View style={styles.circle}>
                                                <Text style={styles.pinText}>
                                                    {' '}
                                                    {this.state.showNativeMarker && marker.nickName}
                                                </Text>
                                            </View>
                                        </MapView.Marker>)
                            })}
                            {this.state.directions &&
                                                (<DirectionsRenderer directions={this.state.directions} />)
                                            }
                        </MapView>
                    </View>
                    <InnerDynamicView style={this.state.tableStyle}>
                        <View>
                            <Table
                                borderStyle={{
                                    borderWidth: 1,
                                    borderColor: '#EF9A19',
                                    marginTop: '10',
                                }}
                            >
                                <Row
                                    data={this.state.tableHead}
                                    widthArr={this.state.widthArr}
                                    style={{height: 30}}
                                    textStyle={{padding: 6, textAlign: 'center' }}
                                />
                            </Table>

                            <View style={styles.wrapper}>
                                <Table borderStyle={{ borderWidth: 1, borderColor: '#EF9A19'}}>
                                    {this.state.tableMarkers.map((marker) => (
                                        <Row
                                            key={marker.nickName}
                                            data={[
                                                this.elementButton(marker),
                                                Math.floor(marker.speed),
                                                marker.LOCATION,
                                                this.getEngineIcon(marker.engine),
                                                this.getVideo(marker.ipport),
                                            ]}
                                            widthArr={this.state.widthArr}
                                            style={[
                                                {height: 28},
                                                marker.selectedMarker && { backgroundColor: '#99CC33' }
                                            ]}
                                            textStyle={{padding: 6, textAlign: 'center' }}
                                        />
                                    ))}
                                </Table>
                            </View>
                        </View>
                        <View style={{ height: '180' }}>
                            <View style={styles.blockButton}>
                                <Button
                                    loading={isLoading}
                                    title="Find All"
                                    containerStyle={{ flex: -1 }}
                                    buttonStyle={styles.findButton}
                                    linearGradientProps={{
                                        colors: ['#FF9800', '#F44336'],
                                        start: [1, 0],
                                        end: [0.2, 0],
                                    }}
                                    ViewComponent={LinearGradient}
                                    titleStyle={styles.findButtonText}
                                    onPress={() => this.findAll()}
                                    disabled={isLoading}
                                />
                            </View>
                            {
                                UserPersistence.getInstance().userName.toLowerCase().startsWith("rct") &&
                                (
                                    <View>
                                        <Text style={styles.blockTitle}>View Route</Text>
                                        <View style={{alignItems: 'center'}}>
                                <Text
                                    style={{ color: 'black', fontSize: 14, padding: 5 }}
                                >
                                    View Date :
                                </Text >
                            
                                <View style={{alignItems: 'center'}}>
                                   
                                    <CustomDatePicker
                                        parentCallBack={this.handleStartChange}
                                        parentSetHeight={()=>(console.log('StartPicker'))}
                                        isDateTimePicker={false}
                                    />
                                </View>
                                
                            </View>
                            <View style={styles.blockButton}>
                                <Button
                                    loading={isLoading}
                                    title="View Route"
                                    containerStyle={{ flex: -1 }}
                                    buttonStyle={styles.findButton}
                                    linearGradientProps={{
                                        colors: ['#FF9800', '#F44336'],
                                        start: [1, 0],
                                        end: [0.2, 0],
                                    }}
                                    ViewComponent={LinearGradient}
                                    titleStyle={styles.findButtonText}
                                    onPress={() => this.viewRoute()}
                                    disabled={isLoading}
                                />
                            </View>
                                    </View>
                                    
                                )
                            }
                            <Text style={styles.blockTitle}>Replay Trace</Text>
                            <View style={{alignItems: 'center'}}>
                                <Text
                                    style={{ color: 'black', fontSize: 14, padding: 5 }}
                                >
                                    Start Time :
                                </Text >
                            
                                <View style={{alignItems: 'center'}}>
                                    {/* <DatePicker
                                        showIcon
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={this.handleStartChange}
                                        selected={this.state.startdate}
                                        dateFormat="MM/dd/yyyy h:mm aa"
                                        placeholderText="Select a date"
                                        timeInputLabel='Time:'
                                        showTimeInput
                                    /> */}
                                    <CustomDatePicker
                                        parentCallBack={this.handleStartChange}
                                        parentSetHeight={()=>(console.log('StartPicker'))}
                                        isDateTimePicker={true}
                                        parentDate={new Date(new Date().setHours(0,0,0,0))}
                                    />
                                </View>
                                <Text
                                    style={{ color: 'black', fontSize: 14, padding: 5 }}
                                >
                                    End Time:
                                </Text>
                            
                                <View style={{alignItems: 'center'}}>
                                    {/* <DatePicker
                                        showIcon
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={this.handleEndChange}
                                        selected={this.state.enddate}
                                        dateFormat="MM/dd/yyyy h:mm aa"
                                        placeholderText="Select a date"
                                        timeInputLabel='Time:'
                                        showTimeInput
                                    /> */}
                                    <CustomDatePicker
                                        parentCallBack={this.handleEndChange}
                                        parentSetHeight={()=>(console.log('EndPicker'))}
                                        isDateTimePicker={true}
                                    />
                                </View>
                            </View>
                            <View style={styles.blockButton}>
                                <Button
                                    loading={isLoading}
                                    title="Replay"
                                    containerStyle={{ flex: -1 }}
                                    buttonStyle={styles.findButton}
                                    linearGradientProps={{
                                        colors: ['#FF9800', '#F44336'],
                                        start: [1, 0],
                                        end: [0.2, 0],
                                    }}
                                    ViewComponent={LinearGradient}
                                    titleStyle={styles.findButtonText}
                                    onPress={() => this.rePlay()}
                                    disabled={isLoading}
                                />
                            </View>
                            <Text style={styles.blockTitle}>Find Stop</Text>
                            <View style={{ alignItems: 'center' }}>
                                <Text
                                    style={{ color: 'black', fontSize: 14, padding: 5 }}
                                >
                                    Start:
                                </Text>
                                
                                <View style={{alignItems: 'center'}}>
                                    {/* <DatePicker
                                        showIcon
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={this.handleStartChange}
                                        selected={this.state.startdate}
                                        dateFormat="MM/dd/yyyy h:mm aa"
                                        placeholderText="Select a date"
                                        timeInputLabel='Time:'
                                        showTimeInput                             
                                    /> */}
                                    <CustomDatePicker
                                        parentCallBack={this.handleStartChange}
                                        parentSetHeight={()=>(console.log('StartPicker'))}
                                        isDateTimePicker={true}
                                        parentDate={new Date(new Date().setHours(0,0,0,0))}
                                    />
                                </View>
                                <Text
                                    style={{ color: 'black', fontSize: 14, padding: 5 }}
                                >
                                    End:
                                </Text>
                                <View style={{alignItems: 'center'}}>
                                    {/* <DatePicker
                                        showIcon
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={this.handleEndChange}
                                        selected={this.state.enddate}
                                        dateFormat="MM/dd/yyyy h:mm aa"
                                        placeholderText="Select a date"
                                        timeInputLabel='Time:'
                                        showTimeInput
                                    /> */}
                                    <CustomDatePicker
                                        parentCallBack={this.handleEndChange}
                                        parentSetHeight={()=>(console.log('EndPicker'))}
                                        isDateTimePicker={true}
                                        parentDate={new Date(new Date().setHours(23,59,59,0))}
                                    />
                                </View>
                            </View>
                            <View
                                style={{
                                    flex: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    paddingTop:5
                                }}
                            >
                              {  <Picker
                                    style={styles.picker}
                                    currentValue={this.state.filter}
                                    options={filterOptions}
                                    onChange={this.onFilterChange}
                            /> }
                            </View>
                            <View style={styles.blockButton}>
                                <Button
                                    loading={isLoading}
                                    title="Find Stop"
                                    containerStyle={{ flex: -1 }}
                                    buttonStyle={styles.findButton}
                                    linearGradientProps={{
                                        colors: ['#FF9800', '#F44336'],
                                        start: [1, 0],
                                        end: [0.2, 0],
                                    }}
                                    ViewComponent={LinearGradient}
                                    titleStyle={styles.findButtonText}
                                    onPress={() => this.findStop()}
                                    disabled={isLoading}
                                />
                            </View>
                        </View>
                    </InnerDynamicView>
                </OutDynamicView>
            </View>
            
        );
    }
}

CustomMarkers.propTypes = {
    provider: ProviderPropType,
    style: PropTypes.object,
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
        marginHorizontal: 0,
        backgroundColor: 'white',
    },
    mapStyleLandscape: {
        backgroundColor: 'transparent',
        width: '80%',
        height: '100%',
        marginRight: 0,
    },
    mapStylePortrait: {
        backgroundColor: 'transparent',
        width: '100%',
        height: '70%',
        marginRight: 0,
    },
    tableStyleLandscape: {
        backgroundColor: '#ffff88',
        width: '20%',
        height: '100%',
        marginRight: 0,
        // fontSize: '10',
    },
    tableStylePortrait: {
        backgroundColor: '#ffff88',
        width: '100%',
        height: '1500',
        marginRight: 10,
    },
    mainStyleLandscape: {
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    mainStylePortrait: {
        width: '100%',
        height: '100%',
        flexDirection: 'column',

    },
    scrollViewLandscape: {
        width: '100%',
        height: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    scrollViewPortrait: {
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    map: {
        ...StyleSheet.absoluteFillObject,
        width: '100%',
        height: '100%',
    },
    btn: { borderRadius: 2 },
    btnText: { color: 'blue', textAlign: 'center' },
    bubble: {
        backgroundColor: 'rgba(255,255,255,0.7)',
        paddingHorizontal: 18,
        paddingVertical: 12,
        borderRadius: 20,
    },
    latlng: {
        width: 200,
        alignItems: 'stretch',
    },
    picker: {
        ...Platform.select({
            ios: {
                position: 'absolute',
                width: '100%',
                left: 0,
            },
            android: {
                margin: 2,
                marginTop: 10,
                width: '25%',
                height: 30,
            },
        }),
        backgroundColor: '#FFFFFF',
    },
    tableContainer: {},
    head: {
        height: 30,
    },
    wrapper: {
        marginTop: -1,
        height: '280',
    },
    title: {
        flex: 1,
        backgroundColor: '#f6f8fa',
    },
    row: {
        height: 28,
    },
    text: {
        margin: 6,
        textAlign: 'center',
    },
    circle: {
        width: 50,
        height: 25,
    },
    pinText: {
        color: 'black',
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
        marginTop: -20,
    },
    callout: {
        backgroundColor: 'black',
        borderRadius: 4,
        alignItems: 'center',
        justifyContent: 'center',
        padding: 4,
    },
    title: {
        color: 'black',
        fontSize: 14,
        lineHeight: 18,
        flex: 1,
        fontFamily: 'spoqaHanSansRegular',
    },
    description: {
        color: '#707070',
        fontSize: 12,
        lineHeight: 16,
        flex: 1,
        fontFamily: 'spoqaHanSansRegular',
    },
    amount: {
        flex: 1,
    },
    arrow: {
        backgroundColor: 'transparent',
        borderWidth: 16,
        borderColor: 'transparent',
        borderTopColor: '#4da2ab',
        alignSelf: 'center',
        marginTop: -32,
    },
    arrowBorder: {
        backgroundColor: 'transparent',
        borderWidth: 16,
        borderColor: 'transparent',
        borderTopColor: '#007a87',
        alignSelf: 'center',
        marginTop: -0.5,
    },
    block: {
        fontSize: '9pt',
        padding: '5px 0 5px 0',
        textAlign: 'left',
    },
    blockTitle: {
        // paddingBottom: '1px',
        fontWeight: 'bold',
        fontSize: '16',
        padding: 10,
    },
    blockButton: {
        // paddingTop: '10px',
        alignSelf: 'center',
        width: '200px',
        padding: 10,
    },
    findButton: {
        backgroundColor: 'rgba(255,255,255, 1)',
        width: 250,
        borderRadius: Math.round(45 / 2),
        height: 45,
    },
    findButtonText: {
        fontFamily: 'UbuntuBold',
        fontSize: 13,
    },
});

export default CustomMarkers;
